module.exports = __webpack_public_path__ + "img/贡献3.27e59ebe.png";